module.exports = __webpack_public_path__ + "img/SKMJ_lift5.dc0aae61.jpg";